import 'css-chunksrc/client/scenes/moveDocument/folderSelection/folder/styles.scss';export default {
  "projectIcon": "_projectIcon_p7hi3_1",
  "folderIcon": "_folderIcon_p7hi3_7",
  "name": "_name_p7hi3_12",
  "selected": "_selected_p7hi3_24"
};